import React from 'react';
import { useSelector } from 'react-redux';
import Navbar from '../components/Navbars/AppNavbar.js';
import Footer from '../components/Footers/Footer.js';
import FooterSM from '../components/Footers/FooterSmall.js';
import AboutComponent from '../components/About';
import Head from 'next/head';
import { NextSeo } from 'next-seo';

export default function Landing() {
  //const userDataRedux = useSelector((state) => state.authReducer.userData);

  const SEO = {
    title: 'About Us - MusicArt',
    description:
      'MusicArt is a unique NFT platform promoting music-based art and imagery. Minting with MusicArt is planet-friendly, simple, and low cost.',
    canonical: 'https://musicart.io/about',
  };

  return (
    <>
      <NextSeo {...SEO} />
      <Head>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1, shrink-to-fit=no"
        />
        {/* <Link  rel="canonical" href="https://musicart.io/about" /> */}
      </Head>

      <Navbar transparent />
      <AboutComponent />
      <Footer />
      <FooterSM />
    </>
  );
}
